<template>
    <div>
        <div class="text-end mb-4" v-if="Object.hasOwn(plugin, 'website')">
            <a :href="plugin.website" target="_blank">
                <v-btn variant="text" color="secondary" class="text-decoration-none">
                    <v-icon class="me-1" size="20">icon-websitekb</v-icon>وبسایت
                </v-btn>
            </a>
        </div>
        <p class="text-small text-justify font-weight-light text-grey-darken-1" v-html="plugin.description"></p>
    </div>
</template>

<script>
export default {
  props: {
    plugin: {
      required: true
    }
  },
};
</script>
